import { Injectable } from "@angular/core";
import { Headers, RequestOptions, URLSearchParams, Http } from "@angular/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/empty";

@Injectable()
export class PurchaseReportService {
  private headers = new Headers({
    "Content-Type": "application/x-www-form-urlencoded",
    Accept: "q=0.8;application/json;q=0.9",
  });
  private invoiceUrl = "api/purchaseinvoice";
  private Url2 = "api/combo2";
  private transferreporturl = "api/stocktransferreport";
  private fabBendreportUrl = "api/fabricBendingReport";
  private reportUrl = "api/invReport";
  private salesUrl = "api/salesOrder";
  private compUrl = "api/lrAgainstGRN";
  private orderUrl = "api/orderAgainstInv";
  private grnRepUrl = "api/grnReport";
  private poreportUrl = "api/poReport";
  private invoiceVSGrnUrl = "api/invoiceVsGrn";
  private postatusreportUrl = "api/poStatusReport";
  private sampleRemainReport = "api/sampleRemainReport";
  private sampleGrnStockReportUrl = "api/sampleGrnStockReport";
  private samplereportUrl = "api/sampledesignReport";
  private sampleFairreportUrl = "api/sampleFairReport";
  private dcreportUrl = "api/clothdcReport";
  private newPurchaseReportUrl = "api/newPurchaseReport";
  private agentWiseReportUrl = "api/agentWiseReport";
  private cpreportUrl = "api/Coreprocessreport";
  private woVsDelPen = "api/workOrderVsDelPen";
  private cdreporturl = "api/cuttingdetailsreport";
  private wadUrl = "api/workActualDgrn";
  private warUrl = "api/workActualRgrn";
  private wopreportUrl = "api/woprocessreport";
  private monthwisewourl = "api/monthwisewo";
  private woreportUrl = "api/woReport";
  private facrtoryStockUrl = "api/factoryStockreport";
  private rdwoReport = "api/rdAgainstReport";
  private agewiseworeportUrl = "api/agewiseworeport";
  private swatchreportUrl = "api/swatchReport";
  private swatchpendingreportUrl = "api/swatchPendingReport";
  private cuttingreportUrl = "api/cuttingReport";
  private compWoUrl = "api/WOAgainstAC";
  private continuosUrl = "api/continuosNumber";
  private fabricUrl = "api/fabricPrint";
  private jgrnUrl = "api/jgrn";
  private fabricStockUrl = "api/fabricStock";
  private factoryDelVsProcessReportUrl = "api/factoryDelVsProcessReport";
  // URL to web api

  constructor(private http: Http) {}

  private extractData(res: any) {
    let body = res.json();
    return body || [];
  }

  getLRinvReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.reportUrl}/getLRinvReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getGrnReport(query: any): Promise<any> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.grnRepUrl}/getGrnReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  getPODesignReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.poreportUrl}/getPODesignReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  getSampleReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.samplereportUrl}/getSampleReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  getSampleFairReport(partyData: any): Promise<any> {
    const url = `${this.sampleFairreportUrl}/getSampleFairReport`;
    return this.http
      .post(url, $.param(partyData), { headers: this.headers })
      .toPromise()
      .then((res) => res.json() as any)
      .catch(this.handleError);
  }

  getDCReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.dcreportUrl}/getDCReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  getSampleGrnStockReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
        params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
        headers: this.headers,
        search: params
    });

    const url = `${this.sampleGrnStockReportUrl}/getSampleGrnStockReport`;
    return this.http.get(url, options)
        .toPromise()
        .then(this.extractData)
        .catch(this.handleError);
}

  getQtyWiseReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.newPurchaseReportUrl}/getQtyWiseReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  getAgentWiseReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.agentWiseReportUrl}/getAgentWiseReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  getWOReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.woreportUrl}/getWOReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getApprovedWOReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.woreportUrl}/getApprovedWOReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getSampleVsWo(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.woreportUrl}/getSampleVsWo`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getFactoryStockreport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.facrtoryStockUrl}/getFactoryStockreport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getagewiseworeport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.agewiseworeportUrl}/getagewiseworeport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getwoRgrnreport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.agewiseworeportUrl}/getwoRgrnreport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  invdiffreport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.grnRepUrl}/invdiffreport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getmonthRgrnreport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.agewiseworeportUrl}/getmonthRgrnreport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getmonthWoprocessreport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.agewiseworeportUrl}/getmonthWoprocessreport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getmonthWoreport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.agewiseworeportUrl}/getmonthWoreport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getRDAgainstReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.rdwoReport}/getRDAgainstReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  designSoReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.salesUrl}/designSoReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  customerSoReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.salesUrl}/customerSoReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  plainDesSoReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.salesUrl}/plainDesSoReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  SoVsStockReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.salesUrl}/SoVsStockReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  plainSoVsStockReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.salesUrl}/plainSoVsStockReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  plainSoorderReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.salesUrl}/plainSoorderReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  designSoStockReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.salesUrl}/designSoStockReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  styleSoReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.salesUrl}/styleSoReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getstocktransferreport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.transferreporturl}/getstocktransferreport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getCoreinprocess(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.cpreportUrl}/Coreprocessreport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getWoFabPending(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.woVsDelPen}/workOrderVsDelPen`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getWorkActualDgrnReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.wadUrl}/getWorkActualDgrnReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getWorkActualRgrnReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.warUrl}/getWorkActualRgrnReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getcuttingdetailsreports(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.cdreporturl}/getcuttingdetailsreport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  woprocessReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.wopreportUrl}/woprocessreport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  monthwisewo(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.monthwisewourl}/monthwisewo`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  getFactoryDelVsProcessReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.factoryDelVsProcessReportUrl}/getFactoryDelVsProcessReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  getCuttingReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.cuttingreportUrl}/getCuttingReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  getFabricStockReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.fabricStockUrl}/getFabricStockReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  splitFabricPieces(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.fabricStockUrl}/splitFabricPieces`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getEditSplitList(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.fabricStockUrl}/getEditSplitList`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getFactoryStockReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.cuttingreportUrl}/getFactoryStockReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getBitListReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.jgrnUrl}/getBitListReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  getwoReturnInwardReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.woreportUrl}/getwoReturnInwardReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  getWOAgainstCuttingReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.compWoUrl}/getWOAgainstCuttingReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  getswatchReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.swatchreportUrl}/getswatchReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  getswatchpendingReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.swatchpendingreportUrl}/getSwatchPendingReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  getswatchColorReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.swatchreportUrl}/getswatchColorReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  getPOOrderReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.poreportUrl}/getPOOrderReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getInvoiceVsGrnReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.invoiceVSGrnUrl}/getInvoiceVsGrnReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getFabricBendingReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.fabBendreportUrl}/getFabricBendingReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getSeason(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.fabBendreportUrl}/getSeason`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getSwatchWoReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.fabBendreportUrl}/getSwatchWoReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  getPoStatusReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.postatusreportUrl}/getPoStatusReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getPurchaseStatusReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.postatusreportUrl}/getPurchaseStatusReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getSampleRemainReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.fabBendreportUrl}/getSampleRemainReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getSampleDcReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.fabBendreportUrl}/getSampleDcReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getPartyStatusReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.postatusreportUrl}/getPartyStatusReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  // getSampleRemanReport(query: any): Promise<any[]> {
  //     let params: URLSearchParams = new URLSearchParams();
  //     for (let key in query) {
  //         params.set(key.toString(), query[key]);
  //     }

  //     let options = new RequestOptions({
  //         headers: this.headers,
  //         search: params
  //     });

  //     const url = `${this.postatusreportUrl}/getSampleRemanReport`;
  //     return this.http.get(url, options)
  //         .toPromise()
  //         .then(this.extractData)
  //         .catch(this.handleError);
  // }

  getInvDesignReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.reportUrl}/getInvDesignReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  getLRDetails(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.invoiceUrl}/getLRDetails`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  getLrVsGRNreport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.compUrl}/getLrVsGRNreport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  getOrderVsInvoiceReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.orderUrl}/getOrderVsInvoiceReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  getContinuosNumber(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.continuosUrl}/getContinuosNumber`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  fabricPrint(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.fabricUrl}/fabricPrint`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getFabricPrint(query: any): Promise<any> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.fabricUrl}/getFabricPrint`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getInvoiceReport(query: any): Promise<any[]> {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in query) {
      params.set(key.toString(), query[key]);
    }

    let options = new RequestOptions({
      headers: this.headers,
      search: params,
    });

    const url = `${this.invoiceUrl}/getInvoiceReport`;
    return this.http
      .get(url, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    //console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/services/purchasereport.service.ts